<ra-modal
    [title]="
        (step() === 'select'
            ? 'order.documentImport.title'
            : 'order.documentImport.modeTitle'
        ) | translate
    "
    [size]="step() === 'mode' ? 'large' : 'medium'"
    (close)="close.emit()">

    <div class="import-documents">

        <!-- ============ PASSO 1: SELEÇÃO ============ -->
        @if (step() === 'select') {

            <!-- Dropzone / botão de seleção -->
            <label
                class="dropzone"
                [class.active]="isDragging()"
                [class.compact]="files().length > 0"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)">

                <input
                    type="file"
                    multiple
                    hidden
                    [accept]="acceptAttr"
                    (change)="onFilesSelected($event)" />

                @if (files().length === 0) {
                    <div class="dz-icon"><ra-icon icon="document-upload" varColor="primary" [size]="28" /></div>
                    <h3>{{ 'order.documentImport.dropTitle' | translate }}</h3>
                    <p class="dz-sub">{{ 'order.documentImport.dropSubtitle' | translate }}</p>
                    <div class="fmt-row">
                        <span class="chip"><i class="doc"></i>Word</span>
                        <span class="chip"><i class="pdf"></i>PDF</span>
                        <span class="chip"><i class="xls"></i>Excel</span>
                        <span class="chip"><i class="ppt"></i>PowerPoint</span>
                    </div>
                } @else {
                    <ra-icon icon="add" varColor="primary" [size]="18" />
                    <span>{{ 'order.documentImport.addMore' | translate }}</span>
                }
            </label>

            <!-- Lista de arquivos selecionados -->
            @if (files().length > 0) {
                <div class="file-list">
                    @for (item of files(); track item.file.name + item.file.size; let i = $index) {
                        <div class="file-item" [class.error]="item.error">
                            <div class="ft" [class]="fileKind(item.file)">{{ fileKind(item.file) | uppercase }}</div>
                            <div class="file-info">
                                <div class="file-name">{{ item.file.name }}</div>
                                @if (item.error) {
                                    <div class="file-sub bad">{{ item.error }}</div>
                                } @else if (isProcessing()) {
                                    <div class="ubar"><div class="ufill" [style.width.%]="progressOf(item.file.name)"></div></div>
                                } @else {
                                    <div class="file-sub">{{ formatSize(item.file.size) }}</div>
                                }
                            </div>
                            @if (!isProcessing()) {
                                <div class="file-remove" (click)="removeFile(i)">
                                    <ra-icon icon="close-square" varColor="contentTertiary" [size]="20" />
                                </div>
                            } @else if (!item.error && progressOf(item.file.name) === 100) {
                                <ra-icon icon="tick" varColor="accentGreen" [size]="20" />
                            }
                        </div>
                    }
                </div>
            } @else {
                <p class="hint">{{ 'order.documentImport.limitsHint' | translate: { max: maxFiles } }}</p>
            }
        }

        <!-- ============ PASSO 2: MODO ============ -->
        @if (step() === 'mode') {
            <p class="mode-subtitle">
                {{ 'order.documentImport.modeSubtitle' | translate: { count: validFiles().length } }}
            </p>

            <div class="modes">
                <div class="mode" [class.sel]="mode() === 'perFile'" (click)="selectMode('perFile')">
                    <div class="mode-icon"><ra-icon icon="copy" [size]="22" /></div>
                    <div class="mode-text">
                        <div class="mode-title">{{ 'order.documentImport.modePerFile' | translate }}</div>
                        <div class="mode-desc">
                            {{ 'order.documentImport.modePerFileDesc' | translate: { count: validFiles().length } }}
                        </div>
                    </div>
                    <div class="radio"></div>
                </div>

                <div
                    class="mode"
                    [class.sel]="mode() === 'merge'"
                    [class.disabled]="!canMerge()"
                    (click)="selectMode('merge')">
                    <div class="mode-icon"><ra-icon icon="document-copy" [size]="22" /></div>
                    <div class="mode-text">
                        <div class="mode-title">{{ 'order.documentImport.modeMerge' | translate }}</div>
                        <div class="mode-desc">{{ 'order.documentImport.modeMergeDesc' | translate }}</div>
                        @if (!canMerge()) {
                            <span class="mode-note">
                                {{ 'order.documentImport.modeMergeLimit' | translate: { max: maxMergeFiles } }}
                            </span>
                        }
                    </div>
                    <div class="radio"></div>
                </div>
            </div>
        }

        <!-- ============ RODAPÉ ============ -->
        <div class="import-footer">
            @if (step() === 'select') {
                <span class="footer-info">
                    @if (batchTooLarge()) {
                        <span class="danger">{{ 'order.documentImport.errors.batchTooLarge' | translate: { max: 300 } }}</span>
                    } @else if (validFiles().length > 0) {
                        {{ 'order.documentImport.selectedCount' | translate: { valid: validFiles().length, total: files().length } }}
                    }
                </span>
                <div class="footer-actions">
                    <ra-button
                        [label]="'order.documentImport.cancel' | translate"
                        [type]="'primary-outline'"
                        [disabled]="isProcessing()"
                        (click)="close.emit()" />
                    <ra-button
                        [label]="
                            (validFiles().length > 1
                                ? 'order.documentImport.continue'
                                : 'order.documentImport.import'
                            ) | translate
                        "
                        [type]="'primary'"
                        [loading]="isProcessing()"
                        [disabled]="!canImport()"
                        (click)="proceed()" />
                </div>
            } @else {
                <div class="footer-actions footer-actions--between">
                    <ra-button
                        [label]="'order.common.back' | translate"
                        [type]="'primary-outline'"
                        [disabled]="isProcessing()"
                        (click)="back()" />
                    <ra-button
                        [label]="'order.documentImport.importCount' | translate: { count: validFiles().length }"
                        [type]="'primary'"
                        [loading]="isProcessing()"
                        [disabled]="!canImport()"
                        (click)="importNow()" />
                </div>
            }
        </div>
    </div>
</ra-modal>
